<template>
    <main class="flex min-h-[calc(100vh-4.5rem)] items-center justify-center bg-nomad-greenish px-6 py-20 text-center text-nomad-primary">
      <div class="max-w-xl rounded-[2rem] bg-white px-8 py-12 shadow-[0_1rem_2.5rem_rgba(23,25,35,0.08)] sm:px-16">
        <p class="text-sm font-extrabold uppercase tracking-[0.16em] text-nomad-accent">Payment not completed</p>
        <h1 class="mt-4 text-4xl font-extrabold tracking-tight sm:text-5xl">Let&apos;s try that again.</h1>
        <p class="mt-4 text-base leading-relaxed text-[#5F626D]">Your payment was not charged. Return to checkout and review your details before trying again.</p>
        <router-link to="/checkout" class="mt-8 inline-flex rounded-full bg-nomad-primary px-5 py-3 text-sm font-extrabold text-white transition hover:bg-black">Return to checkout</router-link>
      </div>
    </main>
  </template>
  
  <script>
  export default {
    name: 'CheckoutError',
  }
  </script>